<!--
 * @Description: 
 * @Author: xiaoyao
 * @since: 2019-08-09 09:55:55
 * @LastAuthor: @yangwenshan
 * @lastTime: 2021-10-15 10:48:39
 -->
<template>
  <a-layout class="layout" :class="[device]">
    <template v-if="layoutMode === 'sidemenu'">
      <a-drawer
        v-show="device === 'mobile'"
        :wrapClassName="'drawer-sider ' + navTheme"
        placement="left"
        @close="() => (this.collapsed = false)"
        :closable="false"
        :visible="collapsed"
      >
        <side-menu
          mode="inline"
          :menus="menus"
          @menuSelect="menuSelect"
          :theme="navTheme"
          :collapsed="false"
          :collapsible="true"
        ></side-menu>
      </a-drawer>

      <side-menu
        v-show="device === 'desktop'"
        mode="inline"
        :menus="menus"
        :theme="navTheme"
        :collapsed="collapsed"
        :collapsible="true"
      ></side-menu>
    </template>
    <!-- 下次优化这些代码 -->
    <template v-else>
      <a-drawer
        v-if="device === 'mobile'"
        :wrapClassName="'drawer-sider ' + navTheme"
        placement="left"
        @close="() => (this.collapsed = false)"
        :closable="false"
        :visible="collapsed"
      >
        <side-menu
          mode="inline"
          :menus="menus"
          @menuSelect="menuSelect"
          :theme="navTheme"
          :collapsed="false"
          :collapsible="true"
        ></side-menu>
      </a-drawer>
    </template>

    <a-layout
      :class="[layoutMode, `content-width-${contentWidth}`]"
      :style="{
        paddingLeft:
          fixSiderbar && isDesktop() ? `${sidebarOpened ? 256 : 80}px` : '0',
      }"
    >
      <!-- layout header -->
      <global-header
        :mode="layoutMode"
        :menus="menus"
        :theme="navTheme"
        :collapsed="collapsed"
        :device="device"
        @toggle="toggle"
      />

      <!-- layout content -->
      <a-layout-content
        :style="{
          margin: '16px 16px 0',
          minHeight: 'auto',
          paddingTop: fixedHeader ? '64px' : '0',
        }"
      >
        <slot></slot>
      </a-layout-content>

      <!-- layout footer -->
      <a-layout-footer style="padding: 0px">
        <global-footer />
      </a-layout-footer>
      <!-- <setting-drawer></setting-drawer> -->
    </a-layout>
    <div :class="(currentStep && !hasOrg) ? 'main-mark' : ''"></div>
  </a-layout>
</template>

<script>
import Vue from "vue";

import ALayout from "ant-design-vue/lib/layout";
import SideMenu from "@/components/Menu/SideMenu";
import GlobalHeader from "@/components/Page/GlobalHeader";
import GlobalFooter from "@/components/Page/GlobalFooter";
import SettingDrawer from "@/components/Settings/SettingDrawer";
import ADrawer from "ant-design-vue/lib/drawer";
import { triggerWindowResizeEvent } from "@/utils/util";
import { mapState, mapActions, mapGetters } from "vuex";
import { mixin, mixinDevice } from "@/utils/mixin.js";

// import { asyncRouterMap } from '@/config/router.config.js'
const ALayoutContent = ALayout.Content;
const ALayoutFooter = ALayout.Footer;
export default {
  name: "GlobalLayout",
  components: {
    ALayout,
    ALayoutContent,
    ALayoutFooter,
    SideMenu,
    GlobalHeader,
    GlobalFooter,
    SettingDrawer,
    ADrawer,
  },
  mixins: [mixin, mixinDevice],
  data() {
    return {
      collapsed: false,
      menus: [],
    };
  },
  computed: {
    ...mapState({
      // 主路由
      mainMenu: (state) => state.permission.addRouters,
    }),
    ...mapGetters(["org", "currentStep"]),
    hasOrg() {
      return Boolean(Object.keys(this.org || {}).length);
    },
  },
  watch: {
    sidebarOpened(val) {
      this.collapsed = !val;
    },
  },
  created() {
    this.menus = this.mainMenu.find((item) => item.path === "/").children;
  },
  methods: {
    ...mapActions(["setSidebar"]),
    showSoftphone(number) {
      this.$refs.softphone.show(number);
    },
    mousedowm(e) {
      // 鼠标按下时的鼠标所在的X，Y坐标
      this.mouseDownX = e.pageX;
      this.mouseDownY = e.pageY;
      // 初始位置的X，Y 坐标
      // this.initX = obj.offsetLeft;
      // this.initY = obj.offsetTop;
      console.log("e", e);
      // 表示鼠标已按下
      this.flag = true;
    },
    mousemove(e) {
      if (this.flag) {
        console.log("e :", e);
      }
    },
    toggle() {
      this.collapsed = !this.collapsed;
      this.setSidebar(!this.collapsed);
      triggerWindowResizeEvent();
    },
    menuSelect() {
      if (!this.isDesktop()) {
        this.collapsed = false;
      }
    },
  },
  directives: {
    drag(el) {
      let oDiv = el; // 当前元素
      // let self = this // 上下文
      // 禁止选择网页上的文字
      // document.onselectstart = function () {
      //   return false
      // }
      oDiv.onmousedown = function (e) {
        // 鼠标按下，计算当前元素距离可视区的距离
        let disX = e.clientX - oDiv.offsetLeft;
        let disY = e.clientY - oDiv.offsetTop;
        document.onmousemove = function (e) {
          // 通过事件委托，计算移动的距离
          let l = e.clientX - disX;
          let b = window.innerHeight - (e.clientY - disY);
          if (l < 0) {
            l = 0;
          } else if (l > window.innerWidth - oDiv.scrollWidth) {
            l = window.innerWidth - oDiv.scrollWidth;
          }
          if (b < oDiv.scrollHeight) {
            b = oDiv.scrollHeight;
          } else if (b > window.innerHeight) {
            b = window.innerHeight;
          }
          // 移动当前元素
          oDiv.style.left = l + "px";
          oDiv.style.bottom = b + "px";
        };
        document.onmouseup = function (e) {
          Vue.ls.set("SoftphoneTopBottom", oDiv.style.bottom);
          Vue.ls.set("SoftphoneLeft", oDiv.style.left);
          document.onmousemove = null;
          document.onmouseup = null;
        };
        // return false不加的话可能导致黏连，就是拖到一个地方时div粘在鼠标上不下来，相当于onmouseup失效
        return false;
      };
    },
  },
};
</script>
<style lang="less">
@import "../global.less";
.softphone-box {
  position: fixed;
  cursor: pointer;
  // opacity: 1;
  z-index: 999;
}
.main-mark {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1029;
  background-color: rgba(0, 0, 0, 0.6);
}
</style>


// WEBPACK FOOTER //
// src/components/Page/GlobalLayout.vue